import { render, staticRenderFns } from "./HeaderTabs.vue?vue&type=template&id=333f67fa&scoped=true&"
import script from "./HeaderTabs.vue?vue&type=script&lang=ts&"
export * from "./HeaderTabs.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderTabs.vue?vue&type=style&index=0&id=333f67fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333f67fa",
  null
  
)

export default component.exports